import React, { Component } from 'react'

import AppPrivate from 'containers/AppPrivate'
import LoadingIndicator from 'components/LoadingIndicator'

class AppPrivateWrapper extends Component {
  componentDidMount() {
    const query = this.props.location.search
    const authToken = new URLSearchParams(query).get('auth')
    if (authToken) {
      this.props.getAuthenticationData(authToken)
    }
  }

  render() {
    if (this.props.loading) {
      return <LoadingIndicator />
    }

    return <AppPrivate {...this.props} />
  }
}

export default AppPrivateWrapper
